import Immutable from 'immutable'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { RecipeCoreId, RecipeUUID } from './types'

/**
 * @deprecated Redux should be avoided in modules
 */
const getBasketRecipes = (state: any) => state.basket.get('recipes', Immutable.List([]))

/**
 * @deprecated Do not access Redux directly, To be removed during coreId -> UUID migration
 */
export const useCoreIdToUUIDMap = () => {
  return useSelector(({ recipesV3 }: any) => recipesV3.coreIdToUUID) as Record<
    RecipeCoreId,
    RecipeUUID
  >
}

export const useBasketRecipeUUIDs = () => {
  const coreIdToUUID = useCoreIdToUUIDMap()

  const basketRecipes = useSelector(getBasketRecipes)

  return useMemo(() => {
    const basketRecipeCoreIds = Object.keys(basketRecipes.toJS())

    return basketRecipeCoreIds
      .map((coreId) => coreIdToUUID[coreId as RecipeCoreId] || null)
      .filter((recipeId): recipeId is RecipeUUID => recipeId !== null)
  }, [basketRecipes, coreIdToUUID])
}
